module.exports = __webpack_public_path__ + "main/assets/public/share-icons/globe.3fc14a16573fea4d.svg";